import React from "react";
import { Modal, Typography } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { ErrorModalWrapper } from "./styled";
import { BlackButton } from "components/Styled";

// TODO: use component/Modal
const ErrorModal = ({ errors, open, setOpen }) => {
  return (
    <Modal
      className="black-mask"
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ErrorModalWrapper>
        <div className="header">
          <CloseOutlinedIcon onClick={() => setOpen(false)} color="primary" />
        </div>
        <div className="content">
          <Typography className="content_item" align="center">
            {Object.entries(errors).map(([key, value]) => (
              <div key={key}>{value || ""}</div>
            ))}
          </Typography>
          <BlackButton
            variant="contained"
            className="close_btn"
            onClick={() => setOpen(false)}
          >
            繼續填寫
          </BlackButton>
        </div>
      </ErrorModalWrapper>
    </Modal>
  );
};
export default ErrorModal;
